module.exports = __webpack_public_path__ + "static/simple-line-08cdc7a81ce5bd1da6c5fa4b4d065668.png";